export default "__VITE_PUBLIC_ASSET__7129233a__"